import React from 'react';
import './FourSteps.css';

export default function FourSteps({ onDesignClick }) {
  const steps = [
    {
      number: 1,
      title: 'Make an Enquiry',
      description: 'Submit a holiday enquiry online or by phone.',
      icon: '🔍'
    },
    {
      number: 2,
      title: 'Speak to an Expert',
      description: 'Discuss your travel plans with your own dedicated Travel Specialist.',
      icon: '🎧'
    },
    {
      number: 3,
      title: 'Receive a Quote',
      description: 'We craft your dream holiday and send you a quote.',
      icon: '📧'
    },
    {
      number: 4,
      title: 'Book Your Trip',
      description: 'Once every detail is just right, we confirm your booking.',
      icon: '✈️'
    }
  ];
  
  return (
    <section className="four-steps">
      <div className="four-steps-container">
        <h2 className="four-steps-title">
          Four Steps to Your <span className="four-steps-highlight">Premium</span> Travel
        </h2>
        <div className="four-steps-grid">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              <div className="four-steps-item">
                <div className="four-steps-icon">
                  {step.icon}
                </div>
                <h3 className="four-steps-item-title">
                  {step.number}. {step.title}
                </h3>
                <p className="four-steps-item-description">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="four-steps-arrow">→</div>
              )}
            </React.Fragment>
          ))}
        </div>
        <button className="four-steps-button" onClick={onDesignClick}>
          DESIGN MY TRIP
        </button>
      </div>
    </section>
  );
}

